import baseUrl from '../baseUrl';

const URL_PUT_CONSELHO_CURADOR_INSCRICAO = `${baseUrl}/user/conselho-curador-inscricao`;

const putConselhoCuradorInscricao = async email => {
  try {
    const response = await fetch(URL_PUT_CONSELHO_CURADOR_INSCRICAO, {
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ email })
    });

    if (!response.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }
  } catch (error) {
    console.log(error);
  }
};

export default putConselhoCuradorInscricao;
